/**
 * Created by Administrador on 08/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('departures', {
                parent: 'app',
                url: '/departures',
                params: {
                    date: "" + (new Date()).getTime() + "",
                    page: "0",
                    size: "100"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/message/departure/departure.html',
                        controller: 'departureCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['departure']);
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
    }
})();
